module.exports = __webpack_public_path__ + "img/5.903ab8e4.jpg";